// import "./CrystalsSection.css";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ProductCard from "../RudrakshaSection/ProductCard";
import Loader from "../Loader/Loader";
import { getProducts } from "../../api/productApi";
import { getCategories } from "../../api/getCategories";
import API_BASE_URL from "../../config";
const CRYSTALS_CATEGORY_SLUG = "crystals";

const banners = [
  "https://i.pinimg.com/1200x/16/e9/e7/16e9e7bba3ad7d2c39748d9574846543.jpg",
  "https://i.pinimg.com/1200x/fe/f7/77/fef777395b19eca113055c160f6e3f36.jpg",
  "https://i.pinimg.com/1200x/8e/c1/50/8ec15037f65000dc74ddf7d16b555b2e.jpg",
];

export default function CrystalsSection() {

  const [crystalsCategory, setCrystalsCategory] =
    useState(null);

  const [subcategories, setSubcategories] =
    useState([]);

  const [activeSubcategory, setActiveSubcategory] =
    useState(null);

  const [products, setProducts] =
    useState([]);

  const [loadingCategories, setLoadingCategories] =
    useState(true);

  const [loadingProducts, setLoadingProducts] =
    useState(false);

  useEffect(() => {

    const fetchCrystalsCategory = async () => {

      try {

        setLoadingCategories(true);

        // GET ALL CATEGORIES
        const result = await getCategories();

        console.log(
          "All Categories:",
          result
        );

        if (!result?.success) {

          setCrystalsCategory(null);
          setSubcategories([]);

          return;
        }

        const categories =
          result?.data || [];

        const crystals = categories.find(
          (category) =>
            category?.slug?.toLowerCase() ===
            CRYSTALS_CATEGORY_SLUG.toLowerCase()
        );

        console.log(
          "Crystals Category:",
          crystals
        );

        if (!crystals) {

          console.error(
            "Crystals category not found"
          );

          setCrystalsCategory(null);
          setSubcategories([]);

          return;
        }

        setCrystalsCategory(crystals);

    
        if (
          Array.isArray(
            crystals.subcategories
          )
        ) {

          setSubcategories(
            crystals.subcategories
          );

        } else {

          const subResponse =
            await fetch(
              `${API_BASE_URL}/categories/${crystals.id}/subcategories`
            );

          const subResult =
            await subResponse.json();

          console.log(
            "Crystals Subcategories:",
            subResult
          );

          if (subResult?.success) {

            setSubcategories(
              subResult.data || []
            );

          } else {

            setSubcategories([]);

          }
        }

      } catch (error) {

        console.error(
          "Crystals Category API Error:",
          error
        );

        setCrystalsCategory(null);
        setSubcategories([]);

      } finally {

        setLoadingCategories(false);

      }

    };

    fetchCrystalsCategory();

  }, []);


  const fetchAllProducts = async (
    categoryId
  ) => {

    try {

      if (!categoryId) return;

      setLoadingProducts(true);

      const result = await getProducts({

        categoryId: categoryId,

        page: 1,

        limit: 12,

      });

      console.log(
        "All Crystals Products:",
        result
      );

      if (result?.success) {

        setProducts(
          result?.data?.products || []
        );

      } else {

        setProducts([]);

      }

    } catch (error) {

      console.error(
        "Crystals Products API Error:",
        error
      );

      setProducts([]);

    } finally {

      setLoadingProducts(false);

    }

  };


  const fetchProductsBySubcategory = async (
    subcategoryId
  ) => {

    try {

      if (
        !crystalsCategory?.id ||
        !subcategoryId
      ) {

        return;
      }

      setLoadingProducts(true);

      const result = await getProducts({

        categoryId:
          crystalsCategory.id,

        subcategoryId:
          subcategoryId,

        page: 1,

        limit: 12,

      });

      console.log(
        "Crystals Products By Subcategory:",
        result
      );

      if (result?.success) {

        setProducts(
          result?.data?.products || []
        );

      } else {

        setProducts([]);

      }

    } catch (error) {

      console.error(
        "Crystals Subcategory Products API Error:",
        error
      );

      setProducts([]);

    } finally {

      setLoadingProducts(false);

    }

  };


  useEffect(() => {

    if (crystalsCategory?.id) {

      setActiveSubcategory(null);

      fetchAllProducts(
        crystalsCategory.id
      );

    }

  }, [crystalsCategory]);

  const handleSubcategoryClick = (
    subcategory
  ) => {

    if (!subcategory?.id) return;

    setActiveSubcategory(
      subcategory.id
    );

    fetchProductsBySubcategory(
      subcategory.id
    );

  };

  const handleAllClick = () => {

    if (!crystalsCategory?.id) return;

    setActiveSubcategory(null);

    fetchAllProducts(
      crystalsCategory.id
    );

  };


  return (

    <section class="rudraksha-section">

      <div className="container">

   
        <div className="section-top">

          <h2>
            Buy Original Crystals & Healing Stones
          </h2>

          <div className="tabs">

            {/* ALL CRYSTALS */}

            <button
              type="button"
              className={
                activeSubcategory === null
                  ? "active"
                  : ""
              }
              onClick={handleAllClick}
              disabled={
                loadingCategories ||
                !crystalsCategory
              }
            >
              All Crystals
            </button>

            {/* API SUBCATEGORIES */}

            {!loadingCategories &&
              subcategories.map(
                (subcategory) => (

                  <button
                    type="button"
                    key={subcategory.id}
                    className={
                      activeSubcategory ===
                      subcategory.id
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleSubcategoryClick(
                        subcategory
                      )
                    }
                  >
                    {subcategory.name}
                  </button>

                )
              )}

          </div>

        </div>

     
        <div className="section-content">

     
          <div className="left-banner">

            <Swiper
              modules={[Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              loop
            >

              {banners.map(
                (image, index) => (

                  <SwiperSlide
                    key={index}
                  >

                    <img
                      src={image}
                      alt="Crystals & Healing Stones"
                    />

                  </SwiperSlide>

                )
              )}

            </Swiper>

          </div>

  
          <div className="right-products">

            {loadingCategories ||
            loadingProducts ? (

              <div className="loading">
                <Loader label="Loading crystals..." size={56} />
              </div>

            ) : products.length === 0 ? (

              <div className="loading">
                No Crystals products found
              </div>

            ) : (

              <Swiper
                modules={[
                  Navigation,
                  Autoplay,
                ]}
                navigation
                loop={
                  products.length > 3
                }
                spaceBetween={10}
                slidesPerView={3}
                breakpoints={{

                  0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },

                  576: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                  },

                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },

                }}
              >

                {products.map(
                  (product) => (

                    <SwiperSlide
                      key={product.id}
                    >

                      <ProductCard
                        product={product}
                      />

                    </SwiperSlide>

                  )
                )}

              </Swiper>

            )}

          </div>

        </div>

      </div>

    </section>

  );
}














